import type { FontRef } from 'shared-types';

/** Plan lettering: ISO 3098 technical font. */
export const PLAN_FONT: FontRef = { source: 'bundled', family: 'osifont' };
